import { cx } from 'class-variance-authority';
import { useState } from 'react';
import type { ResponsiveType } from 'react-multi-carousel';

import Image from '@/app/components/Image';
import MultiCarousel from '@/app/components/MultiCarousel';
import { RESPONSIVE_DATA } from '@/app/components/MultiCarousel/constants';

import FsaSlideshowNavigation from './FsaSlideshowNavigation';
import type { ProductImage } from './types';

const SLIDESHOW_IMAGES: ProductImage[] = [
  {
    localizedAlt: 'hrm_or4_ring_silver_slide_1_alt',
    src: 'heart-rate-monitoring/or4-hsa-fsa-carousel-silver.png',
  },
  {
    localizedAlt: 'hrm_or4_rings_slide_2_alt',
    src: 'heart-rate-monitoring/or4-hsa-fsa-carousel-6-finishes.png',
  },
  {
    localizedAlt: 'heart_rate_slide_4_alt',
    localizedSrc: 'hrm_carousel_heart_rate_app_ui',
  },
  {
    localizedAlt: 'spo2_slide_5_alt',
    localizedSrc: 'hrm_carousel_spo2_app_ui',
  },
];

const RESPONSIVE: ResponsiveType = {
  desktop: { ...RESPONSIVE_DATA['desktop']!, items: 1 },
  tablet: { ...RESPONSIVE_DATA['tablet']!, items: 1 },
  mobile: { ...RESPONSIVE_DATA['mobile']!, items: 1 },
};

const FsaProductSlideshow = () => {
  const [activeSlide, setActiveSlide] = useState<number>(0);

  const handleChange = (nextSlide: number) => {
    setActiveSlide(nextSlide);
  };

  return (
    <section>
      <MultiCarousel
        arrows={false}
        shouldResetAutoplay={false}
        autoPlay={false}
        showDots={false}
        renderButtonGroupOutside={true}
        responsive={RESPONSIVE}
        beforeChange={(nextIndex) => setActiveSlide(nextIndex)}
        customButtonGroup={
          <FsaSlideshowNavigation
            images={SLIDESHOW_IMAGES}
            onChange={handleChange}
          />
        }
      >
        {SLIDESHOW_IMAGES.map(({ localizedAlt, localizedSrc, src }, idx) => (
          <div
            key={localizedAlt}
            className={cx('pointer-events-none select-none', {
              'transition-opacity-750 transition-visibility-750 visible opacity-100':
                activeSlide === idx,
              'transition-opacity-100 transition-visibility-100 hidden opacity-0':
                activeSlide !== idx,
            })}
          >
            <Image
              className="aspect-4/3 w-full"
              draggable="false"
              height={900}
              localizedAlt={localizedAlt}
              localizedSrc={localizedSrc}
              priority={idx === 0}
              src={src}
              width={975}
            />
          </div>
        ))}
      </MultiCarousel>
    </section>
  );
};

export default FsaProductSlideshow;
